export function antDecorator(Vue) {
  return Vue.directive('decorator', {});
}

export default {
  // just for tag
  install: function install(Vue) {
    antDecorator(Vue);
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/_util/FormDecoratorDirective.js
// module id = 3e0t
// module chunks = 16